import React from "react";
import FooterMobile from "./FooterMobile";

const Footer = () => {
  return (
    <>
      <FooterMobile />
    </>
  );
};

export default Footer;
